import { useEffect, useState } from 'react';
import logo from 'assets/img/icons/logo.png';
import logodark from 'assets/img/icons/logo-white.png';
import logos from 'assets/img/icons/slogo.png';
import logodarks from 'assets/img/icons/slogo-white.png';
import logoservi from 'assets/img/icons/servilogo.png';
import logodarkservi from 'assets/img/icons/servilogo-white.png';
import logopfs from 'assets/img/icons/pfslogo.png';
import logodarkpfs from 'assets/img/icons/pfslogo-white.png';
import logoke from 'assets/img/icons/kelogo.png';
import logokedark from 'assets/img/icons/kelogo-white.png';
import logoproa from 'assets/img/icons/proaproptechlogo.png';
import logoproadark from 'assets/img/icons/proaproptechlogo-white.png';
import logosirec from 'assets/img/icons/logosirec.png';
import logosirecdark from 'assets/img/icons/logo-whitesirec.png';
import logoubimia from 'assets/img/icons/logoubimia.png';
import logoubimiadark from 'assets/img/icons/logo-whiteubimia.png';
import classNames from 'classnames';

interface LogoProps {
  width?: number;
  className?: string;
}

const Logo = ({ width = 200, className }: LogoProps) => {
  const companyName = import.meta.env.VITE_COMPANYNAME || 'Zanna';
  const [selectedLogo, setSelectedLogo] = useState<string>(logo);
  const [selectedLogoDark, setSelectedLogoDark] = useState<string>(logodark);

  useEffect(() => {
    // Seleccionar los logotipos adecuados basados en el nombre de la compañía
    if (companyName === 'Serodi') {
      setSelectedLogo(logos);
      setSelectedLogoDark(logodarks);
    } else if (companyName === 'Servinform') {
      setSelectedLogo(logoservi);
      setSelectedLogoDark(logodarkservi);
    } else if (companyName === 'PFS') {
      setSelectedLogo(logopfs);
      setSelectedLogoDark(logodarkpfs);
    } else if (companyName === 'Keldai') {
      setSelectedLogo(logoke);
      setSelectedLogoDark(logokedark);
    } else if (companyName === 'ProaProptech') {
      setSelectedLogo(logoproa);
      setSelectedLogoDark(logoproadark);
    } else if (companyName === 'SIREC') {
      setSelectedLogo(logosirec);
      setSelectedLogoDark(logosirecdark);
    } else if (companyName === 'ubimia') {
      setSelectedLogo(logoubimia);
      setSelectedLogoDark(logoubimiadark);
    } else {
      setSelectedLogo(logo);
      setSelectedLogoDark(logodark);
    }
  }, [companyName]);

  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img
        src={selectedLogo}
        alt={`${companyName} Logo`}
        width={width}
        className="d-dark-none"
      />
      <img
        src={selectedLogoDark}
        alt={`${companyName} Logo Dark`}
        width={width}
        className="d-light-none"
      />
    </div>
  );
};

export default Logo;
